import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';
import MenuListHelper from '../MenuListHelper';
import MenuResumeHelper from '../MenuResumeHelper';
import { UHUU_MKTPC_ID } from '../../../helpers/constants';

const CreateMenuHelper = ({ menus, marketplaces, serviceTypes, step, onConfirm, mktpcHovered }) => {
  const canProceed = () => {
    return serviceTypes.length && marketplaces.some(mktpc => mktpc.active);
  };
  return (
    <styles.Container>
      <styles.Content flexColumn={!!step}>
        {step === 0 ? (
          <Fragment>
            <styles.Title>Lista de Cardápios Criados:</styles.Title>
            <MenuListHelper
              menus={menus.filter(
                menu => !menu.marketplaces.some(mktpc => mktpc === UHUU_MKTPC_ID)
              )}
              marketplaces={marketplaces}
            />
          </Fragment>
        ) : (
          <Fragment>
            <MenuResumeHelper
              marketplaces={marketplaces}
              serviceTypes={serviceTypes}
              mktpcHovered={mktpcHovered}
              menus={menus}
            />
            <styles.ButtonContainer>
              {canProceed() && (
                <styles.Button id="btn-next-step" onClick={onConfirm}>
                  Próximo
                </styles.Button>
              )}
            </styles.ButtonContainer>
          </Fragment>
        )}
      </styles.Content>
    </styles.Container>
  );
};

CreateMenuHelper.propTypes = {
  menus: PropTypes.array,
  step: PropTypes.number,
  marketplaces: PropTypes.array,
  serviceTypes: PropTypes.array,
  onConfirm: PropTypes.func,
  mktpcHovered: PropTypes.object,
};

CreateMenuHelper.defaultProps = {
  menus: [],
  step: 0,
};

export default CreateMenuHelper;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/CreateMenuHelper/index.js